import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';

import List from './List';
import Overview from './Overview';
import New from './New';
import Activities from './Activities';

export default class BusinessUnits extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List
  static Overview = Overview
  static Activities = Activities
  static New = New

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child)
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/BusinessUnits.jsx